module.exports = "/images/nurture.png?6f00cbeb430b28ba7a6b035f10000255";